import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from "hooper";
import "hooper/dist/hooper.css";
import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";
import Slider from "vue-plain-slider";

export default {
  name: "HistorySlider",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    Header,
    Footer,
    Slider
  },
  data() {
    return {
      historyData: {},
      peopleData: {},
      hooperPosition: true,
      showHistoryTab: true,
      showPeopleTab: false
    };
  },
  methods: {
    getHistoryData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/wp/v2/posts?categories=5&_embed&per_page=100"
        )
        .then(function(data) {
          this.historyData = JSON.parse(JSON.stringify(data)).body;
          console.log(this.historyData);
        });
    },

    getPeopleData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/wp/v2/posts?categories=6&_embed&per_page=100"
        )
        .then(function(data) {
          this.peopleData = JSON.parse(JSON.stringify(data)).body;
          console.log(this.peopleData);
        });
    },

    getHooperPosition() {
      if (this.$mq == "mobile") return (this.hooperPosition = false);
      else return (this.hooperPosition = true);
    },

    showProperTab(tabName) {
      console.log(tabName);
      if (tabName == "history") {
        this.showHistoryTab = true;
        this.showPeopleTab = false;
      } else if (tabName == "people") {
        this.showPeopleTab = true;
        this.showHistoryTab = false;
      }
    }
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.getHistoryData();
    this.getPeopleData();
    this.getHooperPosition();
  }
};
